import { i18next } from '@frontend/i18n';
import { IconName } from '@frontend/icons';

export type MetricId = 'appointments' | 'call-intel' | 'forms' | 'raw_payments' | 'phone' | 'sms';

export type MetricOption = {
  id: MetricId;
  label: string;
  icon: IconName;
  show?: boolean;
  availableFrom?: string;
};

export const METRICS_OPTIONS: MetricOption[] = [
  {
    id: 'phone',
    label: i18next.t('Phone', { ns: 'analytics-reporting' }),
    icon: 'phone',
    availableFrom: '2022-06-28',
  },
  {
    id: 'sms',
    label: i18next.t('Messaging', { ns: 'analytics-reporting' }),
    icon: 'message',
    availableFrom: '2023-02-10',
  },
  {
    id: 'appointments',
    label: i18next.t('Appointment', { ns: 'analytics-reporting' }),
    icon: 'calendar',
    availableFrom: '2025-05-13',
  },
  {
    id: 'raw_payments',
    label: i18next.t('Payments', { ns: 'analytics-reporting' }),
    icon: 'payments',
    availableFrom: '2026-05-04',
  },
  {
    id: 'forms',
    label: i18next.t('Forms', { ns: 'analytics-reporting' }),
    icon: 'forms',
    availableFrom: '2026-01-13',
  },
];
